import React from "react";
import PropTypes from "prop-types";

import { add, format } from "date-fns";

export function FutureDate({ period: { of, length } }) {
  return <b>{format(add(new Date(), { [of]: length }), "MMMM d, yyyy")}</b>;
}

FutureDate.propTypes = {
  period: PropTypes.shape({
    of: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
  }).isRequired,
};

export default FutureDate;
